import dynamic from 'next/dynamic';

// Product Components
export const DynamicProduct = dynamic(() => import('./products/Product.js'), {
  loading: () => null,
});

export const DynamicProductCard = dynamic(() => import('./products/ProductCard.js'), {
  loading: () => null,
});

export const DynamicProductModalView = dynamic(() => import('./products/ProductModalView.js'), {
  loading: () => null,
  ssr: false,
});

// Modals
export const DynamicProductModal = dynamic(() => import('./products/ProductModal.js'), {
  loading: () => null,
  ssr: false,
});

export const DynamicActiveOrderModal = dynamic(() => import('./modals/ActiveOrderModal.js'), {
  loading: () => null,
  ssr: false,
});

export const DynamicIframeModal = dynamic(() => import('./modals/IframeModal.js'), {
  loading: () => null,
  ssr: false,
});

export const DynamicMinOrderModal = dynamic(() => import('./modals/MinOrderModal.js'), {
  loading: () => null,
  ssr: false,
});

export const DynamicOrderDetailsModal = dynamic(() => import('./modals/OrderDetailsModal.js'), {
  loading: () => null,
  ssr: false,
});

export const DynamicShippingAreaCheckModal = dynamic(() => import('./modals/ShippingAreaCheckModal.js'), {
  loading: () => null,
  ssr: false,
});

// Checkout Components
export const DynamicCheckoutForm = dynamic(() => import('./checkout/CheckoutForm.js'), {
  loading: () => null,
});

export const DynamicCustomerInfoForm = dynamic(() => import('./checkout/CustomerInfoForm.js'), {
  loading: () => null,
});

export const DynamicPaymentMethodForm = dynamic(() => import('./checkout/PaymentMethodForm.js'), {
  loading: () => null,
});

export const DynamicShippingDetailsForm = dynamic(() => import('./checkout/ShippingDetailsForm.js'), {
  loading: () => null,
});

// My Account Components
export const DynamicMyDetails = dynamic(() => import('./my-account/MyDetails.js'), {
  loading: () => null,
});

export const DynamicMyOrders = dynamic(() => import('./my-account/MyOrders.js'), {
  loading: () => null,
});

export const DynamicMyDownloads = dynamic(() => import('./my-account/MyDownloads.js'), {
  loading: () => null,
});

export const DynamicMobileSearch = dynamic(() => import('./header/MobileSearch.js'), {
  loading: () => null,
  ssr: false,
});

// Category Components
export const DynamicCategorySideBar = dynamic(() => import('./products/CategorySideBar.js'), {
  loading: () => null,
});

export const DynamicMobileCategorySidebar = dynamic(() => import('./products/mobile/MobileCategorySidebar.js'), {
  loading: () => null,
  ssr: false,
});